import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import {getCommentsByFmpTracks} from 'api';
import { Badge } from 'antd';
import FmpAssetCommentsDialog from "../../containers/startproj/Comments/FmpAssetCommentsDialog";

export default withRouter(function FmpAssetCommentsIcon(props) {
  const { project, fmpId, commentGroup ,comments ,phase} = props;

  const [commentsList, setCommentsList] = useState(comments);

  useEffect(() => {
    async function getCommentsById(fmpId, commentGroup) {
      const result = await getCommentsByFmpTracks(fmpId, commentGroup);
      setCommentsList(result);
    }
    getCommentsById(fmpId, commentGroup);
  }, []);

  function commentsConfirm(project) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <FmpAssetCommentsDialog
            project={project}
            onClose={onClose}
            fmpId={fmpId}
            commentGroup={commentGroup}
            commentsList={commentsList}
            setCommentsList={setCommentsList}
            phase={phase}
          />
        );
      },
    });
  }

  return (
    <span style={{ float: 'right' }}>
      <Badge
        size='small'
        count={commentsList && commentsList.length}
        showZero={false}
        title={''}
      >
        <FontAwesomeIcon
          id={'cmticon'}
          icon={faCommentDots}
          pull={'right'}
          size='lg'
          style={{ cursor: 'pointer' }}
          onClick={() => commentsConfirm(project)}
        >
          Comment
        </FontAwesomeIcon>
      </Badge>
    </span>
  );
});
